export const ru = {
    'adjustments-rate':
        'Ставки показаны без учёта применяемых к ним корректировок',
    'see-more': 'Подробнее'
};
